import React, { useState } from "react";
import { ReactComponent as SearchIcon } from "assets/icons/search_main.svg";
import { ReactComponent as ResearchIcon } from "assets/icons/research.svg";
import { ReactComponent as OrganizerIcon } from "assets/icons/organizer.svg";
import { ReactComponent as DashboardIcon } from "assets/icons/dashboard.svg";
import { ReactComponent as SettingsIcon } from "assets/icons/settings.svg";
import { ReactComponent as IdeaIcon } from "assets/icons/idea.svg";
import avatar from "assets/images/avatar.png";
import NavItem from "components/Nav/NavItem";
import { ReactComponent as ArrowRightIcon } from "assets/icons/arrow-right.svg";
import useAuth from "hooks/useAuth";
import useDialog from "hooks/useDialog";
import { useNavigate } from "react-router";
import { motion } from "framer-motion";

const navItems = [
  { to: "/research", Icon: ResearchIcon, label: "Ricerca" },
  { to: "/organizer", Icon: OrganizerIcon, label: "Organizer" },
  { to: "/dashboard", Icon: DashboardIcon, label: "Dashboard" },
  { type: "divider", label: "ALTRO" },
  { to: "/settings", Icon: SettingsIcon, label: "Impostazioni" },
];

const LeftSidebar = () => {
  const { openSigninDialog } = useDialog();
  const { user } = useAuth();
  const navigation = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="w-[80px] hover:w-[268px] group transition-all duration-300 ease-in-out bg-white pt-[42px] pb-[25px] items-center justify-between space-y-3 flex-col border-r-[1px] border-[#E2E4E9] h-[calc(100vh-88px)] sticky left-0 top-[88px] hidden md:inline-flex"
    >
      <div className="w-full">
        <div className="w-full pl-[24px] pr-[20px] mb-[28px]">
          <div
            onClick={() => navigation("/research")}
            className="w-[36px] justify-center group-hover:justify-start group-hover:w-full cursor-pointer h-[38px] group-hover:pl-[17.5px] group-hover:pr-[15px] rounded-[7px] bg-primary flex items-center group-hover:space-x-[15px]"
          >
            <SearchIcon
              width={20}
              height={20}
              stroke="white"
              color="white"
              className="text-white !min-w-[20px]"
            />
            <input
              readOnly
              placeholder="Inizia una nuova ricerca"
              className="outline-none cursor-pointer  opacity-0 flex-1  hidden group-hover:block invisible group-hover:opacity-100 group-hover:visible bg-transparent placeholder:text-white text-white text-[12px] font-normal"
            />
          </div>
        </div>
        <div className=" h-[24px]">
          <h2 className="text-[#868C98] text-[12px] pl-[24px] opacity-0 invisible group-hover:opacity-100 group-hover:visible leading-[16px] font-medium tracking-wider">
            PRINCIPALE
          </h2>
        </div>
        <div className="flex space-y-1 flex-col w-full mt-[4px]">
          {navItems.map((item, index) =>
            item.type === "divider" ? (
              <div key={index} className="!mt-[18px] !mb-[16px] h-[16px]">
                <h2 className="text-[#868C98] text-[12px] pl-[22px] group-hover:pl-[24px] leading-[16px] font-medium tracking-wider">
                  {item.label}
                </h2>
              </div>
            ) : (
              <NavItem
                key={index}
                to={item.to}
                Icon={item.Icon}
                label={item.label}
              />
            )
          )}
        </div>
      </div>
      <div className="h-[267.33px]">
        <motion.div
          initial={{ y: 5, opacity: 0 }}
          transition={{
            duration: isHovered ? 0.3 : 0,
            ease: "linear",
            delay: isHovered ? 0.2 : 0,
          }}
          animate={isHovered ? { y: 0, opacity: 1 } : { opacity: 0 }}
          className="h-[128px] box-border mb-3"
        >
          <div className="ml-[24px]  mr-[20px] bg-[#F6F8FA] rounded-[12px] p-[10px] group-hover:p-4">
            <div className="flex items-center space-x-[6px]">
              <IdeaIcon />
              <h3 className="text-[16px] font-medium leading-[24px] text-[#0A0D14] hidden group-hover:block">
                Hai un’idea?
              </h3>
            </div>
            <p className="font-normal h-[60px] hidden group-hover:block mt-3 text-[14px] leading-[20px] text-[#525866]">
              Contattaci a idea@housescan.it per richiedere una funzionalità
            </p>
          </div>
        </motion.div>
        <div className="pl-[24px] pr-[20px]">
          <hr className="w-full bg-[#E2E4E9] h-[1px] mb-[60px]" />
        </div>
        <div
          onClick={() => (user ? navigation("/settings") : openSigninDialog())}
          className="flex items-center justify-between ml-[16px] group-hover:px-3 py-3 mr-[12px] cursor-pointer hover:bg-[#F6F8FA] transition-all duration-300 ease-in-out rounded-[7px]"
        >
          <div className="flex items-center space-x-3">
            {user ? (
              user?.avatar ? (
                <img
                  src={user.avatar}
                  alt="avatar"
                  className="w-10 h-10 cursor-pointer rounded-full object-cover"
                />
              ) : (
                <div className="w-10 h-10 cursor-pointer rounded-full flex items-center justify-center bg-primary font-bold text-[18px] text-white">
                  {user?.firstName?.charAt(0)?.toUpperCase()}
                </div>
              )
            ) : (
              <img
                src={avatar}
                alt="default avatar"
                className="w-10 h-10 cursor-pointer rounded-full object-cover"
              />
            )}

            <h2 className="text-[14px] hidden group-hover:block font-medium leading-[20px] text-[#0A0D14]">
              {user ? `${user?.firstName} ${user?.lastName}` : "Login"}
            </h2>
          </div>
          <ArrowRightIcon className="hidden group-hover:block" />
        </div>
      </div>
    </div>
  );
};

export default LeftSidebar;
